export default __webpack_public_path__ + "static/media/ProSanteConnect.e478f106.png";